export default "__VITE_ASSET__DkjS0v6S__"